var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-12 col-m-6 mb-s-3 mb-m-0"},[_vm._t("postal")],2),_c('div',{staticClass:"col-12 col-m-6"},[_vm._t("place")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }